import { render, staticRenderFns } from "./testItem-upload.vue?vue&type=template&id=fd384f60&scoped=true&"
import script from "./testItem-upload.vue?vue&type=script&lang=js&"
export * from "./testItem-upload.vue?vue&type=script&lang=js&"
import style0 from "./testItem-upload.vue?vue&type=style&index=0&id=fd384f60&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd384f60",
  null
  
)

export default component.exports